import { render, staticRenderFns } from "./ApiLazyLoadingController.vue?vue&type=template&id=54d9c8cd&"
import script from "./ApiLazyLoadingController.vue?vue&type=script&lang=js&"
export * from "./ApiLazyLoadingController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports